var React = require('react');

function IconReportFunnel (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,0A18,18,0,1,0,36,18,18,18,0,0,0,18,0Zm0,32.57A14.57,14.57,0,1,1,32.57,18,14.58,14.58,0,0,1,18,32.57ZM26.36,10H9.64a.63.63,0,0,0-.64.65V13l7.07,8.25V29l3.86-2.15V21.26L27,13V10.65A.63.63,0,0,0,26.36,10Z"}));
}

IconReportFunnel.defaultProps = {"viewBox":"0 0 36 36"};

module.exports = IconReportFunnel;

IconReportFunnel.default = IconReportFunnel;
